<template>
	<el-dialog
		top="30px"
		title="批量编辑"
		:visible.sync="DetaileddisShow"
		width="60%"
		append-to-body
	>
		<div class="commodityFrame">
			<div
				class="commodityFrame_border"
				v-loading="loading === 'translateSync'"
			>
				<div class="commodityFrame_top border-bottom">
					<el-row type="flex" justify="space-between" align="middle">
						<el-radio-group v-model="checkedCountry" size="small">
							<el-radio-button
								:label="country.areaName"
								v-for="country in countryList"
								:key="country.areaName"
							>
								{{ country.name }}
							</el-radio-button>
						</el-radio-group>
						<el-button
							type="primary"
							size="small"
							v-show="checkedCountry === 'ZH'"
							@click="translateSync"
						>
							翻译并同步
						</el-button>
						<el-button
							type="primary"
							size="small"
							@click="translateSyncLang"
							v-show="translateSyncList.length"
						>
							同步同语言
						</el-button>
					</el-row>
				</div>
				<template v-for="country in countryList">
					<div
						:key="country.areaName"
						v-show="country.areaName === checkedCountry"
					>
						<div
							class="content margin-top1"
							style="overflow: hidden"
						>
							<div class="divspan">标题</div>
							<div style="float: left;width: 80%;">
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title1"
									class="padding custom-input"
								>
									<template slot="prepend">
										开头添加
									</template>
								</el-input>
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title2"
									class="padding custom-input"
								>
									<template slot="prepend">
										中间添加
									</template>
								</el-input>
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title3"
									class="padding custom-input"
								>
									<template slot="prepend">
										结尾添加
									</template>
								</el-input>
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title4"
									class="padding inputlift custom-input"
								>
									<template slot="prepend">
										将标题中的
									</template>
								</el-input>
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title5"
									class="padding inputlift lift custom-input"
								>
									<template slot="prepend">
										替换为
									</template>
								</el-input>
								<el-input
									placeholder="请输入内容"
									v-model="country.formData.title6"
									class="padding custom-input"
								>
									<template slot="prepend">
										标题整体替换
									</template>
								</el-input>
							</div>
						</div>
						<div
							class="content margin-top1"
							style="overflow: hidden;"
						>
							<span class="divspan">产品关键词</span>
							<el-input
								v-model="country.formData.keyword"
								placeholder="请输入内容"
								style="line-height: 40px;width: 80%;"
							></el-input>
						</div>
					</div>
				</template>
				<!-- <div style="line-height: 40px;color: rgb(230, 162, 60);padding: 0 0 0 120px;">
                    注：框内语种可以任意切换，也可以选择整体替换将内容整体替换成统一值。
                </div> -->
			</div>
			<div
				class="content margin-top1 border-bottom padding"
				style="overflow: hidden;"
			>
				<div class="divspan">生成SKU</div>
				<div style="float: left;width: 80%;">
					<el-input
						placeholder="请输入内容"
						v-model="formSku.front"
						class="padding"
						maxlength="10"
					>
						<template slot="prepend">
							前缀
						</template>
					</el-input>
					<el-input
						placeholder="请输入内容"
						v-model="formSku.after"
						class="padding"
						maxlength="10"
					>
						<template slot="prepend">
							后缀
						</template>
					</el-input>
					<div class="contentnumber">
						<div class="contenttext">中间数字位数</div>
						<el-input-number
							v-model="formSku.middle"
							:min="1"
							:max="10"
							label="描述文字"
						></el-input-number>
					</div>
					<el-input
						placeholder="请输入内容"
						v-model="formSku.num"
						class="padding inputlift"
						:maxlength="formSku.middle"
					>
						<template slot="prepend">
							起始数字
						</template>
					</el-input>
					<el-input
						placeholder="请输入内容"
						:value="exampleSku"
						class="padding inputlift lift"
						readonly
					>
						<template slot="prepend">
							生成示例
						</template>
					</el-input>
				</div>
			</div>
			<div
				class="content margin-top1 border-bottom padding"
				style="overflow: hidden;"
			>
				<div class="divspan">产品价格</div>
				<div style="float: left;width: 80%;">
					<div>
						<el-radio v-model="priceType" label="1" border
							>金额</el-radio
						>
						<el-radio v-model="priceType" label="2" border
							>比例</el-radio
						>
						<el-radio v-model="priceType" label="3" border
							>设置</el-radio
						>
					</div>
					<template v-if="priceType === '1'">
						<el-input
							placeholder="请输入内容"
							v-model="price"
							class="padding"
						>
							<template slot="prepend">
								+/-
							</template>
						</el-input>
						<div
							style="line-height: 40px;color: rgb(230, 162, 60);"
						>
							对价格进行加减操作，减价格请输入负数（如：-88)
						</div>
					</template>
					<template v-else-if="priceType === '2'">
						<el-input
							placeholder="请输入内容"
							v-model="price"
							class="padding"
						>
							<template slot="prepend">
								x
							</template>
						</el-input>
						<div
							style="line-height: 40px;color: rgb(230, 162, 60);"
						>
							对价格进行乘除操作
						</div>
					</template>
					<template v-else-if="priceType === '3'">
						<el-input
							v-model="price"
							placeholder="请输入内容"
							style="line-height: 40px;width: 80%;"
						></el-input>
						<div
							style="line-height: 40px;color: rgb(230, 162, 60);"
						>
							将价格统一设置为一个值
						</div>
					</template>
				</div>
			</div>
			<div
				class="content margin-top1 border-bottom padding"
				style="overflow: hidden;"
			>
				<div class="divspan">产品库存</div>
				<div style="float: left;width: 80%;">
					<div>
						<el-radio v-model="stockType" label="1" border
							>数量</el-radio
						>
						<el-radio v-model="stockType" label="2" border
							>设置</el-radio
						>
					</div>
					<template v-if="stockType === '1'">
						<el-input
							placeholder="请输入内容"
							v-model="stock"
							class="padding"
						>
							<template slot="prepend">
								+/-
							</template>
						</el-input>
						<div
							style="line-height: 40px;color: rgb(230, 162, 60);"
						>
							对库存进行加减操作，减库存请输入负数（如：-88)
						</div>
					</template>
					<template v-else-if="stockType === '2'">
						<el-input
							v-model="stock"
							placeholder="请输入内容"
							style="line-height: 40px;width: 80%;"
						></el-input>
						<div
							style="line-height: 40px;color: rgb(230, 162, 60);"
						>
							将库存统一设置为一个值
						</div>
					</template>
				</div>
			</div>
			<div class="margin-top1" style="overflow: hidden;">
				<div style="width: 30%;float: left;">
					<span style="margin-right:10px;">品牌名称</span>
					<el-input
						v-model="formSecond.brand"
						placeholder="品牌名称"
						style="width: 50%;"
					></el-input>
				</div>
				<div style="width: 30%;float: left;">
					<span style="margin-right:10px;">厂商名称</span>
					<el-input
						v-model="formSecond.manufacturer"
						placeholder="厂商名称"
						style="width: 50%;"
					></el-input>
				</div>
				<div style="width: 30%;float: left;">
					<span style="margin-right:10px;">预处理时间</span>
					<el-input
						v-model="formSecond.preprocessingTime"
						placeholder="预处理时间"
						style="width: 50%;"
					>
						<template slot="append">
							天
						</template>
					</el-input>
				</div>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="DetaileddisShow = false">取 消</el-button>
			<el-button
				type="primary"
				@click="batchNone"
				:loading="loadingStatus"
				>确 定</el-button
			>
		</div>
	</el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
const translateSyncCountryList = [
	['GB', 'US', 'CA', 'AU', 'AE', 'IN', 'SG'],
	['ES', 'MX'],
]

export default {
	name: 'commodityFrame',
	data() {
		return {
			DetaileddisShow: false,
			ids: [],
			// 国家列表
			countryList: [
				{
					name: '中国',
					areaName: 'ZH',
					translateUpperName: 'ZH',
					translateLowerName: 'zh',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '英国',
					areaName: 'GB',
					translateUpperName: 'EN',
					translateLowerName: 'en',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '德国',
					areaName: 'DE',
					translateUpperName: 'DE',
					translateLowerName: 'de',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '法国',
					areaName: 'FR',
					translateUpperName: 'FRA',
					translateLowerName: 'fr',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '意大利',
					areaName: 'IT',
					translateUpperName: 'IT',
					translateLowerName: 'it',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '西班牙',
					areaName: 'ES',
					translateUpperName: 'ES',
					translateLowerName: 'es',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '荷兰',
					areaName: 'NL',
					translateUpperName: 'NL',
					translateLowerName: 'nl',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '瑞典',
					areaName: 'SE',
					translateUpperName: 'SE',
					translateLowerName: 'se',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '波兰',
					areaName: 'PL',
					translateUpperName: 'PL',
					translateLowerName: 'pl',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '沙特阿拉伯',
					areaName: 'SA',
					translateUpperName: 'SA',
					translateLowerName: 'sa',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '美国',
					areaName: 'US',
					translateUpperName: 'US',
					translateLowerName: 'us',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '加拿大',
					areaName: 'CA',
					translateUpperName: 'CA',
					translateLowerName: 'ca',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '墨西哥',
					areaName: 'MX',
					translateUpperName: 'MX',
					translateLowerName: 'mx',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '日本',
					areaName: 'JP',
					translateUpperName: 'JP',
					translateLowerName: 'jp',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '澳洲',
					areaName: 'AU',
					translateUpperName: 'AU',
					translateLowerName: 'au',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '阿联酋',
					areaName: 'AE',
					translateUpperName: 'AE',
					translateLowerName: 'ae',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '新加坡',
					areaName: 'SG',
					translateUpperName: 'SG',
					translateLowerName: 'sg',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '印度',
					areaName: 'IN',
					translateUpperName: 'IN',
					translateLowerName: 'in',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
				{
					name: '巴西',
					areaName: 'BR',
					translateUpperName: 'BR',
					translateLowerName: 'br',
					formData: {
						title1: '',
						title2: '',
						title3: '',
						title4: '',
						title5: '',
						title6: '',
						keyword: '',
					},
				},
			],
			isIndeterminate: false,
			checkAll: true,
			checkedCountry: 'ZH',
			priceType: '1',
			price: '',
			stockType: '1',
			stock: '',
			sku: [],
			formSecond: {
				brand: '',
				manufacturer: '',
				preprocessingTime: '',
			},
			formSku: {
				front: '',
				after: '',
				middle: '1',
				num: '0',
			},
			loading: '',
			loadingStatus: false,
		}
	},
	computed: {
		exampleSku() {
			this.sku = this.ids.map((item, index) => {
				let { front, after, middle, num } = this.formSku
				middle = Number(middle)
				index = Number(index)
				num = Number(num)
				num = String(index + num)
				let middleArr = num.split('')
				if (middleArr.length <= middle) {
					const length = middle - middleArr.length
					middleArr = [...Array(length).fill(0), ...middleArr]
				}
				const middleStr = middleArr.join('')
				return `${front}${middleStr}${after}`
			})
			// console.log(this.sku);
			return this.sku[0]
		},
		translateSyncList() {
			const countryInfo = this.countryList.find(
				(item) => item.areaName === this.checkedCountry
			)
			const countryTag = countryInfo.areaName
			const translateSyncList = translateSyncCountryList.find((item) =>
				item.includes(countryTag)
			)
			return translateSyncList || []
		},
	},
	methods: {
		init(ids) {
			this.loadingStatus = false
			this.DetaileddisShow = true
			this.ids = ids
		},
		close() {
			this.DetaileddisShow = false
			this.isIndeterminate = false
			this.checkAll = false
			this.loadingStatus = false
			this.checkedCountry = 'ZH'
			this.priceType = '1'
			this.price = ''
			this.stockType = '1'
			this.stock = ''
			this.sku = []
			this.formSecond = {
				brand: '',
				manufacturer: '',
				preprocessingTime: '',
			}
			this.formSku = {
				front: '',
				after: '',
				middle: '1',
				num: '0',
			}
		},
		batchNone() {
			if (this.loading === 'translateSync') {
				this.$message.warning('请等待翻译完成')
				return
			}
			if (!this.formSku.front && !this.formSku.after) {
				this.sku = []
			}
			if (!!this.price && isNaN(this.price)) {
				this.$message.warning('产品价格只能填入数值')
				return
			}
			if (!!this.stock && isNaN(this.stock)) {
				this.$message.warning('产品库存只能填入数值')
				return
			}
			if (
				!!this.formSecond.preprocessingTime &&
				isNaN(this.formSecond.preprocessingTime)
			) {
				this.$message.warning('预处理时间只能填入数值')
				return
			}
			const content = {}
			const countryMark = []
			this.countryList.forEach(
				(item) => (content[item.areaName] = item.formData)
			)
			for (const key in content) {
				for (const item in content[key]) {
					if (content[key][item]) {
						countryMark.push(key)
						break
					}
				}
			}
			const paramsData = {
				ids: this.ids,
				sku: this.sku,
				price: this.price,
				priceType: this.priceType,
				stock: this.stock,
				stockType: this.stockType,
				countryMark,
				content,
				...this.formSecond,
			}
			let flag = false
			for (const item in paramsData) {
				const whiteList = ['ids', 'priceType', 'stockType', 'content']
				if (whiteList.includes(item)) {
					continue
				}
				if (item === 'sku') {
					if (paramsData.sku.length) {
						flag = true
						break
					}
					continue
				}
				if (item === 'countryMark') {
					if (paramsData.countryMark.length) {
						flag = true
						break
					}
					continue
				}
				if (paramsData[item]) {
					flag = true
					break
				}
			}
			if (!flag) {
				this.$message.warning('请至少输入一项值')
				return
			}
			this.loadingStatus = true
			this.$emit('confirm', paramsData)
		},
		translateSync() {
			this.loading = 'translateSync'
			const API = Baseurl + 'transcationControllor/translatorTitleChToAll'
			const paramsData = {
				...this.countryList[0].formData,
			}
			ajaxPost(API, paramsData)
				.then((res) => {
					const data = res.data
					try {
						this.countryList.forEach((item) => {
							const {
								translateUpperName,
								translateLowerName,
							} = item

							if (translateUpperName !== 'ZH') {
								item.formData.title1 =
									data[translateUpperName][
										`${translateLowerName}_title1`
									]
								item.formData.title2 =
									data[translateUpperName][
										`${translateLowerName}_title2`
									]
								item.formData.title3 =
									data[translateUpperName][
										`${translateLowerName}_title3`
									]
								item.formData.title4 =
									data[translateUpperName][
										`${translateLowerName}_title4`
									]
								item.formData.title5 =
									data[translateUpperName][
										`${translateLowerName}_title5`
									]
								item.formData.title6 =
									data[translateUpperName][
										`${translateLowerName}_title6`
									]
								item.formData.keyword =
									data[translateUpperName][
										`${translateLowerName}_keyword`
									]
							}
						})
						this.$message.success('翻译同步完成！')
					} catch (error) {
						this.$message.warning('翻译同步出错！')
					}
				})
				.finally(() => {
					this.loading = ''
				})
		},
		translateSyncLang() {
			try {
				const countryInfo = this.countryList.find(
					(item) => item.areaName === this.checkedCountry
				)
				const countryTag = countryInfo.areaName
				const translateData = this.countryList.find(
					(item) => item.areaName === countryTag
				)
				this.countryList.forEach((item) => {
					const isSync =
						this.translateSyncList.includes(item.areaName) &&
						item.areaName !== countryTag
					if (isSync) {
						item.formData = { ...translateData.formData }
					}
				})
				this.$message.success('同步完成')
			} catch {
				this.$message.warning('同步出错')
			}
		},
	},
}
</script>
<style lang="scss">
.commodityFrame {
	overflow: hidden;
	.commodityFrame_border {
		padding: 10px;
		border: 1px #b7b4b4 solid;
		.commodityFrame_top {
			padding: 10px 0;
			width: 100%;
		}
	}
	.el-checkbox {
		margin-right: 0px;
	}
	.padding {
		padding: 5px 0;
	}
	.custom-input .el-input__inner {
		text-transform: capitalize;
	}
	.content {
		.divspan {
			width: 120px;
			text-align: center;
			line-height: 40px;
			float: left;
		}

		.inputlift {
			width: 42%;
		}
		.lift {
			margin-left: 5%;
		}
		.contentnumber {
			.el-input__inner,
			.el-input-number {
				height: 30px;
				line-height: 28px;
			}
		}

		.contenttext {
			line-height: 30px;
			float: left;
			margin-right: 10px;
		}
		.el-radio.is-bordered {
			padding: 5px 20px 0 10px;
			height: 26px;
		}
	}
}
</style>
